import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { getConnectedPlugins } from "@/services/pluginStatusApi";
import { Plug, ShieldAlert } from "lucide-react";

export function PluginsStatCard() {
  const navigate = useNavigate();
  const [total, setTotal] = useState<number | null>(null);
  // Nombre de workers en pause sur une « Vérification LinkedIn requise ».
  const [pausedCount, setPausedCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async () => {
    try {
      const res = await getConnectedPlugins(navigate);
      setTotal(res.total);
      setPausedCount(res.plugins.filter((p) => p.linkedin_checkpoint?.active).length);
    } catch {
      setTotal(null);
      setPausedCount(0);
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    fetchData();
    const interval = setInterval(fetchData, 10000);
    return () => clearInterval(interval);
  }, [fetchData]);

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">Plugins actifs</CardTitle>
        <Plug className="h-4 w-4 text-muted-foreground" />
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        ) : total !== null ? (
          <>
            <div className="flex items-center gap-2">
              <div className="text-2xl font-bold">{total}</div>
              <span
                className={`inline-block h-2.5 w-2.5 rounded-full ${total > 0 ? "bg-green-500" : "bg-red-500"}`}
              />
            </div>
            <p className="text-xs text-muted-foreground mt-1">
              {total > 0 ? "Extensions connectees" : "Aucune extension"}
            </p>
            {pausedCount > 0 && (
              <p className="mt-1 flex items-center gap-1 text-xs font-medium text-amber-700">
                <ShieldAlert className="h-3.5 w-3.5 shrink-0" />
                {pausedCount} en pause (vérification LinkedIn)
              </p>
            )}
          </>
        ) : (
          <div className="text-sm text-red-600">Erreur</div>
        )}
      </CardContent>
    </Card>
  );
}
